import base_actions from '@/store/modules/base/actions'
import dayjs from 'dayjs'

/** Prefer API typeahead instead of loading the full catalog beyond this size. */
export const FULL_CATALOG_MAX_LABELS = 5000

/** Single in-flight full-catalog fetch shared by prefetch + manage labels UI. */
let labelFullLoadPromise = null

function labelsAlreadyLoadedForProject(state, projectId) {
    if (!projectId) {
        return true
    }
    return (
        state.loaded === true
        && String(state.loaded_for_project_id) === String(projectId)
    )
}

async function runSharedFullLabelLoad(vm, context, { force = false } = {}) {
    const projectId = sessionStorage.getItem('project_id')
    if (!projectId) {
        return
    }
    const state = context.state
    if (!force && labelsAlreadyLoadedForProject(state, projectId)) {
        return
    }
    if (labelFullLoadPromise) {
        return labelFullLoadPromise
    }
    labelFullLoadPromise = (async () => {
        state.fetching = true
        try {
            if (!force) {
                const total = await vm.$api.label.countProjectLabels()
                context.commit('SET_TOTAL_COUNT', total)
                if (total > FULL_CATALOG_MAX_LABELS) {
                    // Leave loaded=false so SearchLabelAutocomplete keeps using API search.
                    context.commit('SET_LOADED', false)
                    context.commit('SET_LOADED_FOR_PROJECT_ID', null)
                    context.commit('set_items', [])
                    return
                }
            }
            const items = await vm.$api.label.fetchAllProjectLabelsV2()
            const list = Array.isArray(items) ? items : []
            context.commit('set_items', list)
            context.commit('SET_TOTAL_COUNT', list.length)
            context.commit('SET_LOADED', true)
            context.commit('SET_LOADED_FOR_PROJECT_ID', projectId)
            state.updated_at = dayjs()
            state.project_id = projectId
        } finally {
            state.fetching = false
            labelFullLoadPromise = null
        }
    })()
    return labelFullLoadPromise
}

export default {
    ...base_actions
    ,
    /** Start loading full label list in the background (no overlay). Search can use API until this finishes. */
    async prefetch_all_background(context) {
        await runSharedFullLabelLoad(this._vm, context)
    },
    async load_all_for_manage(context) {
        context.commit('SET_LOADING', true)
        try {
            // Manage UI uses server-side pagination; only warm the store for small projects.
            await runSharedFullLabelLoad(this._vm, context)
        } finally {
            context.commit('SET_LOADING', false)
        }
    },
    async refresh_total_count(context) {
        const total = await this._vm.$api.label.countProjectLabels()
        context.commit('SET_TOTAL_COUNT', total)
        return total
    },
    async merge(context, { label_id, merge_label_id, dispatch }) {
        let response = await this._vm.$api[context.state.api_module].merge(label_id, merge_label_id);
        if (response === true) {
            let items = context.state.items.filter(i => i.id !== label_id);
            context.state.items = items;
            if (typeof context.state.total_count === 'number' && context.state.total_count > 0) {
                context.commit('SET_TOTAL_COUNT', context.state.total_count - 1);
            }
            return true;
        }
        const errMsg =
            (response && response.error) ||
            (response && response.data && response.data.error) ||
            'Failed to merge';
        if (dispatch) {
            dispatch('snackbars/add_failed_snack', errMsg);
        }
        return false;
    },    
}
